module.exports = __webpack_public_path__ + "static/media/medic_logo_full.ea0bbf74.png";